import ctl from '@netlify/classnames-template-literals';

export const tableStyle = ctl(`
  w-full 
  bg-ghost-white 
  rounded-t-md
`);
